import classes from './combobox.module.css'

const Combobox = {
  classNames: {
    dropdown: classes.dropdown,
    options: classes.options,
    option: classes.option,
  },
}

export default Combobox
